// Footer.js
import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import LogoImage from "images/logo.png";
import { ReactComponent as FacebookIcon } from "images/facebook-icon.svg";
import { ReactComponent as TwitterIcon } from "images/twitter-icon.svg";
import { ReactComponent as YoutubeIcon } from "images/youtube-icon.svg";

// Rendu hors du conteneur de page (App.js) : pas de marges négatives, sinon la page déborde horizontalement.
const Container = tw.div`relative bg-gray-900 text-gray-100 px-8`;
const Content = tw.div`max-w-screen-xl mx-auto pt-16 pb-8`;
const FiveColumns = tw.div`flex flex-wrap justify-between`;

const Column = tw.div`w-1/2 md:w-1/5 mb-8 md:mb-0 text-sm sm:text-base text-center md:text-left`;
const CompanyColumn = tw.div`text-center md:text-left mb-16 lg:mb-0 w-full lg:w-1/5`;

const ColumnHeading = tw.h5`font-bold uppercase`;

// overflow-wrap: anywhere → l'adresse e-mail (insécable) ne fait plus déborder la colonne sur mobile.
const LinkList = styled.ul`
  ${tw`mt-4 text-sm font-medium`}
  overflow-wrap: anywhere;
`;
const LinkListItem = tw.li`mt-3`;
const Link = tw.a`border-b-2 border-transparent hocus:text-gray-300 hocus:border-gray-100 pb-1 transition duration-300`;

const LogoContainer = tw.div`flex items-center justify-center lg:justify-start`;
const LogoImg = tw.img`w-8`;
const LogoText = tw.h5`ml-2 text-xl font-black`;

const CompanyAddress = tw.p`mt-4 max-w-xs font-medium text-sm mx-auto lg:mx-0 lg:mr-4 leading-loose text-center lg:text-left`;

const SocialLinksContainer = tw.div`mt-4 text-center lg:text-left`;
const SocialLink = styled.a`
  ${tw`cursor-pointer inline-block p-2 rounded-full bg-gray-100 text-gray-900 hover:bg-gray-500 transition duration-300 mr-4 last:mr-0`}
  svg {
    ${tw`w-4 h-4`}
  }
`;

const CopyrightAndCompanyInfoRow = tw.div`pb-0 text-sm font-normal flex flex-col sm:flex-row justify-between items-center`;
const CopyrightNotice = tw.div``;
const CompanyInfo = tw.div``;

const Divider = tw.div`my-8 border-b-2 border-gray-800`;

const Footer = () => {
  return (
    <Container>
      <Content>
        <FiveColumns>
          <CompanyColumn>
            <LogoContainer>
              <LogoImg src={LogoImage} />
              <LogoText>- Besançon</LogoText>
            </LogoContainer>
            <CompanyAddress>
              Besançon, 25000
            </CompanyAddress>
            <SocialLinksContainer>
              <SocialLink href="https://facebook.com">
                <FacebookIcon />
              </SocialLink>
              <SocialLink href="https://twitter.com">
                <TwitterIcon />
              </SocialLink>
              <SocialLink href="https://youtube.com">
                <YoutubeIcon />
              </SocialLink>
            </SocialLinksContainer>
          </CompanyColumn>
          <Column>
            <ColumnHeading>Liens Rapides</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link href="/">Home</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/blog">Blog</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/about">L'équipe</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/about">À propos</Link>
              </LinkListItem>
            </LinkList>
          </Column>
          <Column>
            <ColumnHeading>Le journal</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link href="/blog">Tous les articles</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/blog/categorie/intelligence-artificielle">Intelligence artificielle</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/blog/categorie/formation-emploi">Formation &amp; emploi</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="https://greta-franche-comte.fr/formation/developpeur-intelligence-artificielle/" target="_blank" rel="noopener noreferrer">Formation IA du GRETA</Link>
              </LinkListItem>
            </LinkList>
          </Column>
          <Column>
            <ColumnHeading>Mentions Légales</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link href="/rgpd">RGPD</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/politique">Politique de Confidentialité</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/conditions">Conditions d'Utilisation</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/avertissement">Avertissement</Link>
              </LinkListItem>
            </LinkList>
          </Column>
          <Column>
            <ColumnHeading>Coordonnées</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link href="/contact">Contact</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="tel:+33777770596">+33 7 77 77 05 96</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="mailto:jimmy.inthalangsy@gmail.com">jimmy.inthalangsy@gmail.com</Link>
              </LinkListItem>
            </LinkList>
          </Column>
        </FiveColumns>
        <Divider />
        <CopyrightAndCompanyInfoRow>
          <CopyrightNotice>&copy; Copyright {new Date().getFullYear()}, ia-besancon | Jimmy Inthalangsy.</CopyrightNotice>
          <CompanyInfo>IA, tech &amp; innovation dans le bassin de Besançon.</CompanyInfo>
        </CopyrightAndCompanyInfoRow>
      </Content>
    </Container>
  );
};

export default Footer;
